import { render, staticRenderFns } from "./SearchCompanyIds.vue?vue&type=template&id=2b76c4c7&scoped=true&"
import script from "./SearchCompanyIds.vue?vue&type=script&lang=js&"
export * from "./SearchCompanyIds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b76c4c7",
  null
  
)

export default component.exports